import React from 'react';
import {Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import  Home from './pages/Home';
import BlogPages from './pages/BlogPage'; // Create this component for blog details
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Services from './pages/Services';
import Posts from './pages/Posts';

import './App.css';

function App() {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/AboutUs" element={<AboutUs />} /> */}
        <Route path="/Services" element={<Services />} />
        <Route path="/Blog/:id" element={<BlogPages />} />
        <Route path="/Posts" element={<Posts />} />

      </Routes>
      <Footer />
    </div>
  );
};

export default App;
